import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppInsightPage } from '../Models/AppInsight/AppInsightPage';

export default function useCurrentPage() {
  const location = useLocation();
  const [page, setPage] = useState(() => determinePage(location.pathname));

  useEffect(() => {
    setPage(determinePage(location.pathname));
  }, [location.pathname]);

  return page;
}

function determinePage(pathname: string) {
  if (pathname.includes('/batch')) return AppInsightPage.ALL_CATEGORY_SWAP;
  if (pathname.includes('/swaps')) return AppInsightPage.SKU_SWAP_PAGE;
  if (pathname.includes('/products')) return AppInsightPage.PRODUCTS_PAGE;
  return AppInsightPage.LANDING_PAGE;
}
